<script>
    import SubBasic from './sub/subBasic.svelte'
    import SubSkill from './sub/subSkill.svelte'
    import ModalMonster from './modal/modalMonster.svelte'

	import { onMount } from 'svelte'
    import { GetMonsterSkill } from '../../script/_monster'
    import { CheckLink } from '../../script/handle/write'


    export let Monster, Position, CheckTab

    let ShowMonseterModal = false
    let active = 1, Section = -1, SkillData = []

	onMount(async () => {
        //console.log(Monster);
    })

    // 몬스터 선택 Modal 호출
    function callMonsterModal() {
        ShowMonseterModal = true
    }

    // 세부 텝 선택
    function selectTab(_tab) {
        active = _tab

        if(_tab == 2) {
            Section = 0
            // 특정 몬스터의 스킬 데이터 불러오기
            SkillData = GetMonsterSkill(Monster.monster, Section)
        }
        else if(_tab == 3) {
            Section = 1
            // 특정 몬스터의 스킬 데이터 불러오기
            SkillData = GetMonsterSkill(Monster.monster, Section)
        }
    }
</script>

<div class="top">
    <div class="left" on:click={callMonsterModal}>
        <img src="{CheckLink()}/img/monsters/{Monster.monster}/monster.png" alt="{Monster.monster}">
        <div class="name">
            {Monster.name}
        </div>
    </div>

    <svg xmlns="http://www.w3.org/2000/svg" width="51" height="12" viewBox="0 0 51 12" fill="none">
        <line x1="3" y1="5.5" x2="45" y2="5.5" stroke="#7A67FF" stroke-width="3"/>
        <rect x="39" y="5.53564" width="7.82858" height="7.82858" transform="rotate(-45 39 5.53564)" fill="#7A67FF"/>
        <rect y="5.53564" width="7.82858" height="7.82858" transform="rotate(-45 0 5.53564)" fill="#7A67FF"/>
    </svg>

    <div class="right">
        <div class="menu">
            <div class="tab top"
                class:active={active==1} class:full={CheckTab[0]}
                on:click={() => selectTab(1)}
            >
                기본
            </div>

            <div class="tab middle"
                class:active={active==2} class:full={CheckTab[1]}
                on:click={() => selectTab(2)}
            >
                액티브
            </div>
            
            <div class="tab bottom"
                class:active={active==3} class:full={CheckTab[2]}
                on:click={() => selectTab(3)}
            >
                패시브
            </div>
        </div>

        <div class="inputPage">
            {#if active == 1}
                <SubBasic
                    bind:Monster={Monster.monster}
                    bind:Temperament={Monster.temperament}
                    bind:Equipment={Monster.equipment}
                />
            {:else if active == 2 || active == 3}
                <SubSkill
                    bind:Monster={Monster.monster}
                    bind:Section
                    bind:Skill={Monster.skills[Section]}
                    bind:SkillData
                />
            {/if}
        </div>
    </div>
</div>

<ModalMonster bind:ShowMonseterModal bind:SelectPosition={Position}/>

<style lang="scss">
    .top {
        width: calc(100%);
        height: fit-content;

        .left {
            width: calc(25% - 26px);
            height: 100%;
            text-align: center;

            display: inline-block;
            vertical-align: middle;
            cursor: pointer;

            img { width: 100%; }
            .name {
                color: $cl3;
                margin-top: 10px;
                font-size: 15px;
                font-family: aggro;
            }
        }

        svg { display: inline-block; }

        .right { 
            width: calc(75% - 26px);
            height: fit-content;

            display: inline-block;
            vertical-align: top;

            .menu {
                display: inline-block;

                .tab {
                    background: $cl2;
                    width: fit-content;
                    height: fit-content;
                    padding: 10px 6px;
                    color: $cl3;
                    font-size: 14px;
                    font-family: aggro;
                    writing-mode: vertical-lr;

                    &.active {
                        background: $cl3;
                        color: $cl2;
                    }

                    &:hover:not(.active) {
                        background: $cl3;
                        color: $cl2;
                        cursor: pointer;
                    }

                    &.full {
                        background: $cl6;
                        color: $cl2;
                    }
                }
            }

            .inputPage {
                width: calc(100% - 40px - 4px - 35px);
                height: fit-content;
                min-height: calc(196px - 20px - 4px);
                padding: 20px;
                padding-bottom: 0;
                border: 2px solid $cl3;
                display: inline-block;
                vertical-align: top;
            }
        }
    }
</style>